// extracted by mini-css-extract-plugin
module.exports = {"checkbox__group":"EpCheckboxGroup_checkbox__group__c5Jed","checkbox__legend":"EpCheckboxGroup_checkbox__legend__Jj80F"};